module.exports = __webpack_public_path__ + "assets/images/project/thailand.jpg?v=58a400e7";